import React, { useContext, useState } from 'react';
import { useForm } from 'react-hook-form';
import toast from 'react-hot-toast';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { AiFillEye, AiFillEyeInvisible } from "react-icons/ai";
import { AuthContext } from '../../Context/UseContext';
import login from '../../assets/Login.png';
import useTitle from '../../hooks/useTitle';
import useScrollToTop from '../../hooks/useScrollToTop';
import { setJwtToken } from '../../custom/setJwtToken';
import SmallSpinner from '../../Component/Spinner/SmallSpinner';
import { getCurrentDate } from '../../custom/getCurrentDate';
import { showAuthErrorToast } from '../../custom/showAuthErrorToast';

const Login = () => {
    useScrollToTop();
    useTitle("Login");
    const { register, formState: { errors }, handleSubmit, reset } = useForm();
    const { signin, resetPassword, signInWithGoogle, loading, setLoading } = useContext(AuthContext)
    const [loginError, setLoginError] = useState('');
    const location = useLocation();
    const navigate = useNavigate();

    const [userEmail, setUserEmail] = useState('')

    const [showPass, setShowPass] = useState(false)

    const from = location.state?.from?.pathname || '/';

    const date = getCurrentDate();

    const handelLogin = data => {
        setLoginError('')
        setLoading(true)
        signin(data.email, data.password)
            .then(result => {
                const user = result.user
                setJwtToken(user.email)
                // setLoginUserEmail(data.email)
            reset();

                navigate(from, { replace: true });
                toast.success(`Welcome back ${user.displayName}`);
            })
            .catch(error => {
                setLoading(false)
                setLoginError(error.message)
            });
    }

    const passwordHandler = (e) => {
        e.preventDefault()
        resetPassword(userEmail)
            .then(() => {
                toast.success('password reset email sent, please check your email.')
                setLoading(false)
            })
            .catch((error) => {
                // console.error(error)
                showAuthErrorToast(error)
                setLoading(false)
            })
    }

    const handelEmail = (e) => {
        e.preventDefault()
        // console.log(e.target.value)
        setUserEmail(e.target.value)
    }

    const handleGoogle = () => {
        signInWithGoogle()
        .then(result => {
            const {displayName, email, photoURL} = result.user;
            const user = {
                name: displayName,
                    email,
                    role: "Buyer",
                    isVerified: false,
                    image: photoURL,
                    joinDate: date
            }
            saveUser(user)
            navigate(from, { replace: true })
        })
    }

    const saveUser = (name, email, image, role = "Buyer", verify = false, joinDate) => {
        const user = { name, email, role, image, verify, joinDate };
        fetch(`${process.env.REACT_APP_API_URL}/users`, {
            method: 'PUT',
            headers: {
                'content-type': 'application/json'
            },
            body: JSON.stringify(user)
        })
            .then(res => res.json())
            .then(data => {
                console.log(data)
                if (data.acknowledged) {
                    toast.success(`Welcome back ${data.user.displayName}`)
                    setJwtToken(data.user.email)
                    reset();
                    navigate(from, { replace: true });
                }

            }).catch ((err) => {
                setLoading(false)
                showAuthErrorToast(err);
                // setSubmitLoading(false);
            })
    }

    return (
        <div className="flex w-full max-w-sm mx-auto overflow-hidden bg-white rounded-lg shadow-lg dark:bg-gray-800 lg:max-w-4xl">
            
            <div className="hidden bg-cover lg:block lg:w-1/2">
                <img src={login} alt="" style={{ height: "500px", width: "500px" }}/>
            </div>

            <div className="w-full px-6 py-8 md:px-8 lg:w-1/2">
                <h2 className="text-2xl font-semibold text-center text-gray-700 dark:text-white">
                    Brand
                </h2>

                <p className="text-xl text-center text-gray-600 dark:text-gray-200">
                    Welcome back!
                </p>
                

                
                <Link onClick={handleGoogle} href="#" className="flex items-center justify-center mt-4 text-gray-600 transition-colors duration-300 transform border rounded-lg dark:border-gray-700 dark:text-gray-200 hover:bg-gray-50 dark:hover:bg-gray-600">
                    <div className="px-4 py-2">
                        <svg className="w-6 h-6" viewBox="0 0 40 40">
                            <path d="M36.3425 16.7358H35V16.6667H20V23.3333H29.4192C28.045 27.2142 24.3525 30 20 30C14.4775 30 10 25.5225 10 20C10 14.4775 14.4775 9.99999 20 9.99999C22.5492 9.99999 24.8683 10.9617 26.6342 12.5325L31.3483 7.81833C28.3717 5.04416 24.39 3.33333 20 3.33333C10.7958 3.33333 3.33335 10.7958 3.33335 20C3.33335 29.2042 10.7958 36.6667 20 36.6667C29.2042 36.6667 36.6667 29.2042 36.6667 20C36.6667 18.8825 36.5517 17.7917 36.3425 16.7358Z" fill="#FFC107" />
                            <path d="M5.25497 12.2425L10.7308 16.2583C12.2125 12.59 15.8008 9.99999 20 9.99999C22.5491 9.99999 24.8683 10.9617 26.6341 12.5325L31.3483 7.81833C28.3716 5.04416 24.39 3.33333 20 3.33333C13.5983 3.33333 8.04663 6.94749 5.25497 12.2425Z" fill="#FF3D00" />
                            <path d="M20 36.6667C24.305 36.6667 28.2167 35.0192 31.1742 32.34L26.0159 27.975C24.3425 29.2425 22.2625 30 20 30C15.665 30 11.9842 27.2359 10.5975 23.3784L5.16254 27.5659C7.92087 32.9634 13.5225 36.6667 20 36.6667Z" fill="#4CAF50" />
                            <path d="M36.3425 16.7358H35V16.6667H20V23.3333H29.4192C28.7592 25.1975 27.56 26.805 26.0133 27.9758C26.0142 27.975 26.015 27.975 26.0158 27.9742L31.1742 32.3392C30.8092 32.6708 36.6667 28.3333 36.6667 20C36.6667 18.8825 36.5517 17.7917 36.3425 16.7358Z" fill="#1976D2" />
                        </svg>
                    </div>

                    <span className="w-5/6 px-4 py-3 font-bold text-center">Sign in with Google</span>
                </Link>

                <div className="flex items-center justify-between mt-4">
                    <span className="w-1/5 border-b dark:border-gray-600 lg:w-1/4"></span>

                    <h1 className="text-xs text-center text-gray-500 uppercase dark:text-gray-400 hover:underline">or login
                        with email</h1>

                    <span className="w-1/5 border-b dark:border-gray-400 lg:w-1/4"></span>
                </div>
                <form onSubmit={handleSubmit(handelLogin)}>
                    <div className="mt-4">
                        <label className="block mb-2 text-sm font-medium text-gray-600 dark:text-gray-200" htmlFor="LoggingEmailAddress">Email Address</label>
                        <input 
                            {...register("email",
                                {
                                    required: "Email Address is required"
                                })} className="block w-full px-4 py-2 text-gray-700 bg-white border rounded-md dark:bg-gray-800 dark:text-gray-300 dark:border-gray-600 focus:border-blue-400 focus:ring-opacity-40 dark:focus:border-blue-300 focus:outline-none focus:ring focus:ring-blue-300" onChange={handelEmail}
                        id="LoggingEmailAddress" type="email" />
                        {errors.email && <p className='text-red-600'>{errors.email?.message}</p>}
                    </div>
                    <div className="mt-4 relative">
                        <div className="flex justify-between">
                            <label className="block mb-2 text-sm font-medium text-gray-600 dark:text-gray-200" htmlFor="loggingPassword">Password</label>
                            {/* The button to open modal */}
                            <label htmlFor="my-modal" className="text-xs text-gray-500 dark:text-gray-300 hover:underline cursor-pointer" >Forget Password?</label>
                        </div>
                        <input id="loggingPassword"
                            {...register("password",
                                {
                                    // required: "Password is required",
                                    minLength: { value: 6, message: 'Password must be 6 character ' }

                                })} 
                        className="block w-full px-4 py-2 text-gray-700 bg-white border rounded-md dark:bg-gray-800 dark:text-gray-300 dark:border-gray-600 focus:border-blue-400 focus:ring-opacity-40 dark:focus:border-blue-300 focus:outline-none focus:ring focus:ring-blue-300" type={showPass ? 'text' : "password"} />
                        <div className="absolute right-3 top-9" onClick={() => setShowPass(!showPass)}>
                            {showPass ? <AiFillEyeInvisible className='h-6 w-6' /> : <AiFillEye className='h-6 w-6' />}
                        </div>
                        {errors.password && <p className='text-red-600'>{errors.password?.message}</p>}
                    </div>
                    {loginError && <p className='text-red-600'>{loginError.slice(22, -2)}</p>}
                    <div className="mt-8">
                        <button className="w-full px-4 py-2 tracking-wide text-white transition-colors duration-300 transform bg-gray-700 rounded hover:bg-gray-600 focus:outline-none focus:bg-gray-600">
                            {loading ? <SmallSpinner /> : "Login"}
                        </button>
                    </div>
                </form>

                <div className="flex items-center justify-between mt-4">
                    <span className="w-1/5 border-b dark:border-gray-600 md:w-1/4"></span>
                    <Link to='/signup' className="text-xs text-gray-500 uppercase dark:text-gray-400 hover:underline">or sign up</Link>
                    <span className="w-1/5 border-b dark:border-gray-600 md:w-1/4"></span>
                </div>
            </div>
            <>
                {/* Put this part before </body> tag */}
                <input type="checkbox" id="my-modal" className="modal-toggle" />
                <div className="modal">
                    <div className="modal-box relative">
                        <label htmlFor="my-modal" className="btn btn-sm btn-circle absolute right-2 top-2">✕</label>
                        <div className="space-y-6 px-6 pb-4 sm:pb-6 lg:px-8 xl:pb-8 text-center">
                            <h3 className="text-xl font-medium text-gray-900 dark:text-white">
                                Reset your password
                            </h3>
                            <form onSubmit={passwordHandler}>
                                <div className="flex flex-col mb-2">
                                    <div className="flex relative ">
                                        <span className="rounded-l-md inline-flex  items-center px-3 border-t bg-white border-l border-b  border-gray-300 text-gray-500 shadow-sm text-sm">
                                            <svg
                                                width="15"
                                                height="15"
                                                fill="currentColor"
                                                viewBox="0 0 1792 1792"
                                                xmlns="http://www.w3.org/2000/svg"
                                            >
                                                <path d="M1792 710v794q0 66-47 113t-113 47h-1472q-66 0-113-47t-47-113v-794q44 49 101 87 362 246 497 345 57 42 92.5 65.5t94.5 48 110 24.5h2q51 0 110-24.5t94.5-48 92.5-65.5q170-123 498-345 57-39 100-87zm0-294q0 79-49 151t-122 123q-376 261-468 325-10 7-42.5 30.5t-54 38-52 32.5-57.5 27-50 9h-2q-23 0-50-9t-57.5-27-52-32.5-54-38-42.5-30.5q-91-64-262-182.5t-205-142.5q-62-42-117-115.5t-55-136.5q0-78 41.5-130t118.5-52h1472q65 0 112.5 47t47.5 113z"></path>
                                            </svg>
                                        </span>
                                        <input
                                            type="email"
                                            id="email"
                                            name="email"
                                            className=" rounded-r-lg flex-1 appearance-none border border-gray-300 w-full py-2 px-4 bg-white text-gray-700 placeholder-gray-400 shadow-sm text-base focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent"
                                            placeholder="Your email"
                                        />
                                    </div>
                                </div>

                                <div className="flex w-full">
                                    <button
                                        type="submit"
                                        className="py-2 px-4  bg-blue-600 hover:bg-blue-700 focus:ring-blue-500 focus:ring-offset-blue-200 text-white w-full transition ease-in duration-200 text-center text-base font-semibold shadow-md focus:outline-none focus:ring-2 focus:ring-offset-2  rounded-lg mt-4"
                                    >
                                        {loading ? <SmallSpinner /> : "Reset"}
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </>
        </div>
        
    );
};

export default Login;